// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import './assets/css/mint.css'
import gallery from 'img-vuer'

Vue.config.productionTip = false

Vue.use(MintUI)

Vue.use(gallery, {
  swipeThreshold: 100,
  isIndexShow: false,
  useCloseButton: false
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js